module.exports = __webpack_public_path__ + "static/media/about-content-bg.4abef75c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about-content-bg.png
// module id = 1972
// module chunks = 0